import React from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import TargetGroup from './TargetGroup'

const OwnedData = ({ uiStore, t }) => (
  <ul className='owned-data'>
    {uiStore.myDisplayGroups.length > 0
      ? uiStore.myDisplayGroups.map((group) => (
        <TargetGroup key={group.pk} group={group} />
      ))
      : <p className='item-list__empty'>No items</p>}
  </ul>
)

export default withTranslation()(inject(
  'uiStore',
  'dataStore',
  'selectionStore'
)(observer(OwnedData)))
